import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueI18n from "vue-i18n";

Vue.config.productionTip = false;

/*ELEMENT UI*/
import ElementUI from "element-ui";
import ElementScss from "./style/element-variables.scss";
Vue.use(ElementUI);

/*引入川辰vue开发包*/
import ccVueUtils from "./components/cc-vue-utils";
ccVueUtils.ccRequest.setAppId("fosber"); // 这是由后台分配的APPID识别号，接口调用都需要用到
ccVueUtils.ccRequest.setBaseUrl("/");
ccVueUtils.ccRequest.setLoginPage("/vueapp/index.html#/admin/sys/login"); // 这是由后台分配的APPID识别号，接口调用都需要用到

Vue.use(ccVueUtils);

/*引入API设置的列表*/
import APIS from "./api/api-config.js";
Vue.prototype.$apis = APIS;

/*引入川辰adminUi框架*/
import ccAdminUi from "cc-admin-ui";
Vue.use(ccAdminUi);
Vue.component("CcUploader", ccAdminUi.CcUploaderAliMultiV2);

//上传工具方法
import uploadUtils from "./utils/ossUtils.js";
Vue.prototype.$uploadUtils = uploadUtils;

import timeUtils from "./utils/time";
Vue.prototype.$timeUtils = timeUtils;

import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
Vue.use(VideoPlayer);

import Base from "./utils/base";
Vue.use(Base);

/*引入常量管理组件*/
import CcConstantAdmin from "./components/cc-constant-admin";
Vue.use(CcConstantAdmin);

/** 设置路由守卫 用于返回上一页的时候根据 name 选择其返回的对应位置
 * 如： 创建完客户 => 客户详情 ，然后在客户详情的时候 点击返回不回到客户创建，回到客户列表
 *     而从配件订单进入客户详情的时候，返回的时候就应该是配件订单
 * */
Vue.prototype.$prevRouter = "";
router.beforeEach((to, from, next) => {
  // console.log(from, "Vue.prototype.$prevRouter = from;");
  Vue.prototype.$prevRouter = from;
  next();
});

/**
 * 定义当前语言，用于中英文转换
 * */
let lange = "zh";
if (
  localStorage.getItem("lange") &&
  localStorage.getItem("lange") != "undefined"
) {
  lange = localStorage.getItem("lange");
}
Vue.prototype.$lange = lange;
Vue.prototype.$showIframe = false;
Vue.prototype.$setShowIframe = function(booleanData) {
  Vue.prototype.$showIframe = booleanData;
};

//新版多語言設置
import zh from "./language/zh";
import en from "./language/en";
import uiEn from "./language/ui/uiEn";
import uiZh from "./language/ui/uiZh";
let langData = {
  zh: {
    ...uiZh,
    ...zh,
  },
  en: {
    ...uiEn,
    ...en,
  },
};
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: lange, // 语言标识
  messages: {
    // 'zh': ccAdminUi.ZhLang,
    zh: langData.zh,
    en: langData.en,
  },
});
import localeEn from "element-ui/lib/locale/lang/en";
import localeZh from "element-ui/lib/locale/lang/zh-CN";
import locale from "element-ui/lib/locale";
if (lange == "en") {
  locale.use(localeEn);
  localStorage.setItem("lange", "en");
} else {
  locale.use(localeZh);
  localStorage.setItem("lange", "zh");
}

Vue.mixin({
  data() {
    return {};
  },
  methods: {
    language(name) {
      return this.$t(name);
    },
    newWindow(data) {
      console.log(process.env.VUE_APP_type);
      if (process.env.VUE_APP_type == "dev") {
        window.open(window.origin + "/#" + data.url);
      } else {
        window.parent.postMessage(
          { url: "vueapp/index.html#" + data.url, name: data.name },
          "*"
        );
      }
    },
    //获取登陆者信息 如角色
    getValidate(data={}) {
      return new Promise((resolve, reject) => {
        this.ccRequest
          .do(`validate`, data, "GET")
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {},
});
new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
